import React from 'react';
import { Menu, Bell, User, Search } from 'lucide-react';

const AdminHeader = ({ toggleSidebar, isOpen }) => {
  return (
    <header className="admin-header">
      <div className="header-left">
        <button onClick={toggleSidebar} className="hamburger-btn">
          <Menu size={24} />
        </button>
        <div className="header-search">
          <Search size={18} className="search-icon" />
          <input type="text" placeholder="Search data..." />
        </div>
      </div>

      <div className="header-right">
        <button className="header-icon-btn">
          <Bell size={20} />
          <span className="notification-dot"></span>
        </button>
        <div className="header-profile">
          <div className="profile-img">A</div>
          <span>Admin</span>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;